import { CognitoUser } from 'amazon-cognito-identity-js';
import {
  REACT_APP_API_BASE_URL,
  REACT_APP_COGNITO_REGION,
  REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  REACT_APP_COGNITO_USER_POOL_ID,
} from '../configs';
import { APIApi } from './server';
import { Auth } from 'aws-amplify';

export const getToken = async () => {
  let token = '';
  try {
    const user = (await Auth.currentAuthenticatedUser()) as CognitoUser;
    token =
      user
        .getSignInUserSession()
        ?.getIdToken()
        .getJwtToken() ?? '';
  } catch (error) {
    console.error('getToken error: ', error);
  }
  return token;
};
export const axiosOptions = async () => {
  return { headers: { Authorization: `Bearer ${getToken()}` } };
};
export const serverApi = (() => {
  Auth.configure({
    region: REACT_APP_COGNITO_REGION,
    userPoolId: REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  });
  return new APIApi({
    isJsonMime: (mime: string): boolean => {
      const jsonMime: RegExp = new RegExp(`^(application/json|[^;/ \t]+/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i'`);
      return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    },
    basePath: REACT_APP_API_BASE_URL,
    baseOptions: axiosOptions(),
  });
})();

export const requestServerApi = async <T>(callback: () => T) => {
  await serverApi.getAxiosOptions();
  return await callback();
};
